var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Box } from "theme-ui";
import { LinkVariants } from "../../theme/enums";
export const BreadCrumbItem = (_a) => {
    var { active = false, children } = _a, props = __rest(_a, ["active", "children"]);
    return (_jsx(Box, Object.assign({ as: "li", className: active ? "active" : "", sx: {
            variant: `links.${LinkVariants.breadcrumb}`
        } }, props, { children: children })));
};
//# sourceMappingURL=BreadCrumbItem.js.map